/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assignee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Assignee({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Assignee",
  setOuterRef,
  disabled,
  left,
  top,
  setInnerRef
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let taskAssigneeValueData = fromData.useDataFormat({ viewPath,
context: 'task',
path: 'assignee',
format: fromHelpers.getAssigneeName,
})
let dtFontsizesMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'fontSizes.mm'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Assignee.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Zm2L2M': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Assignee.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Assign to"
/>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 innerRef={setOuterRef}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2UserSingleCircle
{...childProps}
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 weight="medium"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 fontSize={dtFontsizesMm}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral900}
 data="task.assignee"
 format="helpers.js getAssigneeName"
 text={taskAssigneeValueData}
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={14}
 height={14}
 fill2={disabled ? dtColorsNeutral300 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
</div>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}